import { render, staticRenderFns } from "./exportConfig.vue?vue&type=template&id=52703cb0&scoped=true&"
import script from "./exportConfig.vue?vue&type=script&lang=js&"
export * from "./exportConfig.vue?vue&type=script&lang=js&"
import style0 from "./exportConfig.vue?vue&type=style&index=0&id=52703cb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52703cb0",
  null
  
)

export default component.exports